import { createContext, useContext, useState, useCallback } from "react";
import { CONTENT } from "@/data/content";

const LanguageContext = createContext(null);

const removeTerminalPeriods = (value) => {
  if (typeof value === "string") return value.endsWith(".") ? value.slice(0, -1) : value;
  if (Array.isArray(value)) return value.map(removeTerminalPeriods);
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, removeTerminalPeriods(item)])
    );
  }
  return value;
};

const CONTENT_WITHOUT_TERMINAL_PERIODS = Object.fromEntries(
  Object.entries(CONTENT).map(([language, content]) => [language, removeTerminalPeriods(content)])
);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const toggle = useCallback(
    () => setLang((l) => (l === "it" ? "en" : "it")),
    []
  );
  const t = CONTENT_WITHOUT_TERMINAL_PERIODS[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
